
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class InputPhone extends Vue {
  countryNum: string = "1";
  phone: string = "";
  @Prop({ default: "" })
  height: string;
}
